import { motion } from "framer-motion";
import { Reveal, SectionLabel } from "@/components/site/bits";
import { scrollToSection } from "@/lib/scroll";
import {
  Clapperboard, Globe, Smartphone, PhoneCall, Workflow, Code2,
  LayoutDashboard, Palette, Headphones, Settings2, ArrowUpRight,
} from "lucide-react";

const SERVICES = [
  { icon: Clapperboard, title: "AI Business Promotional Videos", desc: "Cinematic AI-generated promos and ads at 10x speed.", span: "lg:col-span-2" },
  { icon: Globe, title: "Website Development", desc: "Fast, SEO-first, conversion-focused websites." },
  { icon: Smartphone, title: "Mobile App Development", desc: "Cross-platform apps with native performance." },
  { icon: PhoneCall, title: "AI Voice Calling Agents", desc: "Human-like voice agents that qualify & convert.", span: "lg:col-span-2" },
  { icon: Workflow, title: "Business Process Automation", desc: "Automate repetitive workflows end to end." },
  { icon: Code2, title: "Custom Business Software", desc: "Bespoke platforms built around your ops." },
  { icon: LayoutDashboard, title: "CRM & Sales Portals", desc: "Unified pipelines with predictive scoring." },
  { icon: Palette, title: "Social Media Creatives", desc: "On-brand daily creatives, powered by AI." },
  { icon: Headphones, title: "AI Customer Support Systems", desc: "24/7 chat & ticket resolution.", span: "lg:col-span-2" },
  { icon: Settings2, title: "Business Operations Automation", desc: "Orchestrate teams, tools and data." },
];

export default function Services() {
  return (
    <section id="services" className="relative py-28 px-6" data-testid="services">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <SectionLabel>What We Do</SectionLabel>
          <h2 className="font-display text-4xl md:text-5xl font-bold tracking-tight max-w-2xl">
            A full-stack AI studio for <span className="text-gradient">modern businesses</span>
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal key={s.title} delay={(i % 4) * 0.06} className={s.span || ""}>
                <motion.div
                  whileHover={{ y: -6 }}
                  transition={{ type: "spring", stiffness: 300, damping: 20 }}
                  className="group relative h-full overflow-hidden rounded-2xl glass p-7 hover:border-[#00E5FF]/40"
                  data-testid={`service-card-${i}`}
                >
                  <div className="absolute -right-10 -top-10 h-24 w-24 rounded-full bg-[#00E5FF]/0 blur-2xl transition-colors duration-500 group-hover:bg-[#00E5FF]/20" />
                  <div className="grid h-11 w-11 place-items-center rounded-xl bg-white/5 border border-white/10 group-hover:border-[#00E5FF]/50 transition-colors">
                    <Icon className="h-5 w-5 text-[#00E5FF]" />
                  </div>
                  <h3 className="mt-5 font-display text-lg font-semibold">{s.title}</h3>
                  <p className="mt-2 text-sm text-white/60 leading-relaxed">{s.desc}</p>
                  <button
                    onClick={() => scrollToSection("contact")}
                    className="mt-5 inline-flex items-center gap-1 text-sm text-[#00FFB2] opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all"
                  >
                    Learn More <ArrowUpRight className="h-3.5 w-3.5" />
                  </button>
                </motion.div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
